var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qr-code',_vm._g(_vm._b({staticClass:"root qr-code",style:({ width: (_vm.width + "px"), height: (_vm.width + "px")}),attrs:{"options":{ width: _vm.width, margin: _vm.margin },"value":_vm.value}},'qr-code',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }